import { Injectable } from '@angular/core';
import { CreatorPermission } from '../enums/creator-permisson.enum';
import { Employee } from '@shared/models/employee.model';

@Injectable({
  providedIn: 'root',
})
export class ProjectCreatorPermissionResolverService {
  constructor() {}

  resolvePermissions(employee: Employee, previewAction: string, editAction: string): CreatorPermission[] {
    return [CreatorPermission.PREVIEW, CreatorPermission.EDIT];
  }
}
